import React from 'react';
import { Link } from 'react-router-dom';

const SidebarLink = ({ icon, label, active = false, to = "#" }) => {
  const content = (
    <>
      <span className={`${active ? 'text-white' : 'text-slate-400 group-hover:text-blue-500'}`}>{icon}</span>
      <span className="flex-grow text-left">{label}</span>
    </>
  );

  const className = `flex items-center gap-4 w-full px-5 py-3.5 text-xs font-bold transition-all border-b border-slate-50 last:border-0 ${
    active 
      ? 'bg-[#003366] text-white shadow-md z-10' 
      : 'text-slate-500 hover:bg-slate-50 hover:text-blue-600'
  }`;

  if (to.startsWith('/')) {
    return (
      <Link to={to} className={className}>
        {content}
      </Link>
    );
  }

  return (
    <button className={className}>
      {content}
    </button>
  );
};

export default SidebarLink;
